import { LOCALE_EN, LOCALE_KO, LocaleType } from '../../../modules/i18n/config'
import { s_blog, s_home, s_menu } from '../../../modules/i18n/strings/auto/wording'
import { STUDENT_BTN_ID } from '../../../modules/ids/gtm/student'
import urls from '../../../modules/urls'
import { t } from '../../../modules/utils'
import {
  IMG_NAVIGATION_HELP_ICON_ACTIVE,
  IMG_NAVIGATION_HELP_ICON_INACTIVE,
  IMG_NAVIGATION_HOME_ICON_ACTIVE,
  IMG_NAVIGATION_HOME_ICON_INACTIVE,
  IMG_NAVIGATION_MATERIAL_ICON_ACTIVE,
  IMG_NAVIGATION_MATERIAL_ICON_INACTIVE,
  IMG_NAVIGATION_PRICING_ICON_ACTIVE,
  IMG_NAVIGATION_PRICING_ICON_INACTIVE,
  IMG_NAVIGATION_PROMOTION_ICON_ACTIVE,
  IMG_NAVIGATION_PROMOTION_ICON_INACTIVE,
  IMG_NAVIGATION_TUTOR_ICON_ACTIVE,
  IMG_NAVIGATION_TUTOR_ICON_INACTIVE,
} from '../constants/navigation.constant'
import {
  BOTTOM_NAVIGATION_ITEM_ID,
  IBottomNavigationBarItem,
  NAVIGATION_BAR_HREF_TYPE,
} from '../interface/navigation.interface'

export const BOTTOM_NAVIGATION_BAR_ITEM_LIST: (
  isLoggedIn: boolean,
  locale: LocaleType,
  promotionOn: boolean
) => IBottomNavigationBarItem[] = (isLoggedIn: boolean, locale: LocaleType, promotionOn: boolean) => [
  {
    id: STUDENT_BTN_ID.CLICK_BOTTOM_NAVIGATION_HOME,
    itemId: BOTTOM_NAVIGATION_ITEM_ID.HOME,
    href: urls.oneOnOne.index,
    type: NAVIGATION_BAR_HREF_TYPE.WITHIN,
    isVisible: true,
  },
  {
    id: STUDENT_BTN_ID.CLICK_BOTTOM_NAVIGATION_TUTOR,
    itemId: BOTTOM_NAVIGATION_ITEM_ID.TUTOR,
    href: urls.oneOnOne.tutor,
    type: NAVIGATION_BAR_HREF_TYPE.WITHIN,
    isVisible: true,
  },
  {
    id: STUDENT_BTN_ID.CLICK_BOTTOM_NAVIGATION_MATERIAL,
    itemId: BOTTOM_NAVIGATION_ITEM_ID.MATERIAL,
    href: urls.oneOnOne.material,
    type: NAVIGATION_BAR_HREF_TYPE.WITHIN,
    isVisible: true,
  },
  {
    id: STUDENT_BTN_ID.CLICK_BOTTOM_NAVIGATION_PRICING,
    itemId: BOTTOM_NAVIGATION_ITEM_ID.PRICING,
    href: isLoggedIn ? urls.student.newPortal.pricing.index : urls.student.landing.pricing,
    type: NAVIGATION_BAR_HREF_TYPE.WITHIN,
    isVisible: true,
  },
  {
    id: STUDENT_BTN_ID.CLICK_BOTTOM_NAVIGATION_PROMOTION,
    itemId: BOTTOM_NAVIGATION_ITEM_ID.PROMOTION,
    href: locale == LOCALE_KO ? urls.student.newPortal.promotion.newYear : urls.student.newPortal.promotion.newYearEn,
    type: NAVIGATION_BAR_HREF_TYPE.WITHIN,
    isVisible: promotionOn,
  },
  {
    id: STUDENT_BTN_ID.CLICK_BOTTOM_NAVIGATION_HELP,
    itemId: BOTTOM_NAVIGATION_ITEM_ID.HELP,
    href: urls.student.landing.faq,
    type: NAVIGATION_BAR_HREF_TYPE.WITHIN,
    isVisible: !promotionOn,
  },
]

export const BOTTOM_NAVIGATION_ITEM_ICON_URL: Record<BOTTOM_NAVIGATION_ITEM_ID, string[]> = {
  [BOTTOM_NAVIGATION_ITEM_ID.HOME]: [IMG_NAVIGATION_HOME_ICON_ACTIVE, IMG_NAVIGATION_HOME_ICON_INACTIVE],
  [BOTTOM_NAVIGATION_ITEM_ID.MATERIAL]: [IMG_NAVIGATION_MATERIAL_ICON_ACTIVE, IMG_NAVIGATION_MATERIAL_ICON_INACTIVE],
  [BOTTOM_NAVIGATION_ITEM_ID.TUTOR]: [IMG_NAVIGATION_TUTOR_ICON_ACTIVE, IMG_NAVIGATION_TUTOR_ICON_INACTIVE],
  [BOTTOM_NAVIGATION_ITEM_ID.PROMOTION]: [IMG_NAVIGATION_PROMOTION_ICON_ACTIVE, IMG_NAVIGATION_PROMOTION_ICON_INACTIVE],
  [BOTTOM_NAVIGATION_ITEM_ID.HELP]: [IMG_NAVIGATION_HELP_ICON_ACTIVE, IMG_NAVIGATION_HELP_ICON_INACTIVE],
  [BOTTOM_NAVIGATION_ITEM_ID.PRICING]: [IMG_NAVIGATION_PRICING_ICON_ACTIVE, IMG_NAVIGATION_PRICING_ICON_INACTIVE],
}

export const BOTTOM_NAVIGATION_ITEM_TEXT: Record<BOTTOM_NAVIGATION_ITEM_ID, string[]> = {
  [BOTTOM_NAVIGATION_ITEM_ID.HOME]: ['홈', 'Home'],
  [BOTTOM_NAVIGATION_ITEM_ID.MATERIAL]: ['교재', 'Material'],
  [BOTTOM_NAVIGATION_ITEM_ID.TUTOR]: ['튜터', 'Tutor'],
  [BOTTOM_NAVIGATION_ITEM_ID.PROMOTION]: ['프로모션', 'Promotion'],
  [BOTTOM_NAVIGATION_ITEM_ID.HELP]: ['고객센터', 'Help Center'],
  [BOTTOM_NAVIGATION_ITEM_ID.PRICING]: ['가격', 'Pricing'],
}

export const HEADER_NAVIGATION_BAR_ITEM_LIST = (
  isLoggedIn: boolean,
  locale: LocaleType,
  promotionOn: boolean | { [x: string]: boolean },
  eventGnbData: any
) => [
  {
    id: STUDENT_BTN_ID.CLICK_MENU_TUTOR,
    title: t(s_menu.landing.tutor, locale),
    href: urls.oneOnOne.tutor,
    type: NAVIGATION_BAR_HREF_TYPE.WITHIN,
    inActiveTextColor: '#7C7F94',
    activeTextColor: '#000000',
    isVisible: true,
  },
  {
    id: STUDENT_BTN_ID.CLICK_MENU_MATERIALS,
    title: t(s_menu.landing.lesson_materials, locale),
    href: urls.oneOnOne.material,
    type: NAVIGATION_BAR_HREF_TYPE.WITHIN,
    inActiveTextColor: '#7C7F94',
    activeTextColor: '#000000',
    isVisible: true,
  },
  {
    id: STUDENT_BTN_ID.CLICK_MENU_PRICING,
    title: t(s_menu.landing.pricing, locale),
    href: isLoggedIn ? urls.student.portal.pricing.index : urls.student.landing.pricing,
    type: NAVIGATION_BAR_HREF_TYPE.WITHIN,
    inActiveTextColor: '#7C7F94',
    activeTextColor: '#000000',
    isVisible: true,
  },
  ...eventGnbData,
  {
    id: STUDENT_BTN_ID.CLICK_MENU_BUSINESS,
    title: t(s_menu.landing.b2b, locale),
    href: urls.b2b.index,
    type: NAVIGATION_BAR_HREF_TYPE.WITHIN,
    inActiveTextColor: '#7C7F94',
    activeTextColor: '#000000',
    isVisible: true,
  },
  {
    id: STUDENT_BTN_ID.CLICK_MENU_RINGLE_GUIDE,
    title: t(s_blog.category.ringle_guide, locale),
    href: null,
    type: NAVIGATION_BAR_HREF_TYPE.DROPDOWN,
    inActiveTextColor: '#7C7F94',
    activeTextColor: '#000000',
    isVisible: true,
    dropdownList: [
      {
        title: t(s_menu.conversation.ringle_guide, locale),
        href: urls.student.landing.blog.index + '#3',
        type: NAVIGATION_BAR_HREF_TYPE.WITHIN,
      },
      {
        title: t(s_home.review_title.subtitle.desktop, locale),
        href: urls.student.landing.blog.tags('링글 후기'),
        type: NAVIGATION_BAR_HREF_TYPE.WITHIN,
      },
      {
        title: t(s_blog.title.blog, locale),
        href: urls.student.landing.blog.index,
        type: NAVIGATION_BAR_HREF_TYPE.WITHIN,
      },
    ],
  },
]

export const HEADER_NAVIGATION_RIGHT_BAR_ITEM_LIST = (locale: LocaleType) => [
  {
    id: STUDENT_BTN_ID.CLICK_MENU_BECOME_A_TUTOR,
    title: 'Become a Tutor',
    href: urls.tutor.landing.home,
    type: NAVIGATION_BAR_HREF_TYPE.WITHIN,
    inActiveTextColor: '#7C7F94',
    activeTextColor: '#000000',
    isVisible: locale === LOCALE_EN,
  },
  {
    id: STUDENT_BTN_ID.CLICK_TEENS,
    title: '틴즈',
    href: 'https://www.ringleteens.com/ko/teens/landing/home',
    type: NAVIGATION_BAR_HREF_TYPE.OUTBOUND,
    inActiveTextColor: '#7C7F94',
    activeTextColor: '#000000',
    isVisible: locale === LOCALE_KO,
  },
]
